// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MercadoPagoConfig from '../components/paymentProviderConfigs/MercadoPagoConfig';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    error: state.paymentMethodConfig.error,
    isDeleting: state.paymentMethodConfig.isDeleting,
    isFetching: state.paymentMethodConfig.isFetching,
    isSaving: state.paymentMethodConfig.isSaving,
    updateSuccess: state.paymentMethodConfig.updateSuccess,
    deleteSuccess: state.paymentMethodConfig.deleteSuccess,
    addSuccess: state.paymentMethodConfig.addSuccess,
    paymentMethod: state.paymentMethodConfig.paymentMethod,
    paymentMethods: state.paymentMethodConfig.paymentMethods,
    currency: state.currency.currency,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...actions,
      },
      dispatch
    )
)(MercadoPagoConfig);
